
import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { StyleSheet } from 'aphrodite';
import thunkMiddleware from 'redux-thunk';

import reducer from './components/Header/reducers';

import Header from './components/Header/Header.jsx';

// Grab the state from a global variable injected into the server-generated HTML
const preloadedState = window.__PRELOADED_NAV_STATE__;
const preloadedClasses = window.__PRELOAD_NAV_CLASSES__;
// const configVariables = window.__NAV_CONFIG__;

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_NAV_STATE__;
delete window.__PRELOAD_NAV_CLASSES__;
delete window.__NAV_CONFIG__;

const store = createStore(reducer, preloadedState, applyMiddleware(thunkMiddleware));

StyleSheet.rehydrate(preloadedClasses);

render(
    <Provider store={store}>
        <Header />
    </Provider>,
    document.getElementById('nav_container')
);



// WEBPACK FOOTER //
// ./src/main.js